<template>
  <div class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Tambah IUJPTL</h4>
          <button type="button" class="btn btn-sm" v-on:click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="kbli-modal-filter-search" style="padding: 0 10px">
          <form v-on:submit.prevent="noop">
            <div class="input-search">
              <b-input-group>
                <template #append>
                  <b-input-group-text>
                    <strong>
                      <i
                        class="fas fa-times"
                        style="cursor:pointer; marginRight: 10px"
                        @click="resetPlaceholder()"
                        v-if="subSearch.length !== '' && subSearch"
                      ></i>
                      <i class="fas fa-search" style="cursor:pointer"></i>
                    </strong>
                  </b-input-group-text>
                </template>
                <b-form-input
                  type="text"
                  placeholder="Cari IUJPTL"
                  v-model="subSearch"
                  @keyup="searchRun()"
                ></b-form-input>
              </b-input-group>
            </div>
          </form>
        </div>
        <div class="modal-body" v-if="iujptlData">
          <div class="horizontal">
            <div class="column5"></div>
            <div class="column10">Jenis Usaha</div>
            <div class="column20 mr10">Bidang</div>
            <div class="column40 mr10">Sub Bidang</div>
            <div class="column20">Kualifikasi</div>
          </div>
          <div class="horizontal" v-for="(item, index) in iujptl" :key="index">
            <div class="column5">
              <input
                class="modal-input-checkbox"
                type="checkbox"
                :id="index"
                :value="item.id"
                v-model="iujptl[index]['checked']"
              />
            </div>
            <div class="column10 all-column">{{ item.jenis_usaha }}</div>
            <div class="column20 mr10">{{ item.bidang }}</div>
            <div class="column40 mr10">{{ item.sub_bidang }}</div>
            <div class="column20">{{ item.kualifikasi }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" v-on:click="submit">
            Selesai
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      iujptl: [],
      subData: [],
      subSearch: '',
    }
  },
  computed: {
    iujptlData: async function() {
      const getIujptl = await this.$getIujptl()
      const defaultIujptl = await this.$store.state.landingpage.addedIujptl

      let reduceIujptl = await getIujptl.reduce(
        (a, b) => ({ ...a, [b.id]: b }),
        {}
      )
      let reduceDefault =
        (await defaultIujptl) &&
        defaultIujptl.reduce((a, b) => ({ ...a, [b.id]: b }), {})

      let combine = { ...reduceIujptl, ...reduceDefault }

      let newIujptl = await Object.values(combine)
      this.iujptl = newIujptl.sort((a, b) => this.$sortAsc(a, b))
      this.subData = newIujptl.sort((a, b) => this.$sortAsc(a, b))
    },
  },
  methods: {
    async searchRun(id) {
      const search = String(this.subSearch)
      const list = this.subData

      let filteredList = []
      for (let i in list) {
        if (
          list[i].sub_bidang.toLowerCase().indexOf(search.toLowerCase()) != -1
        ) {
          filteredList.push(list[i])
        }
      }

      this.iujptl = filteredList
    },
    resetPlaceholder() {
      this.subSearch = ''
      // this.iujptl = this.subData
      this.searchRun()
    },
    async submit() {
      await this.resetPlaceholder()

      let filterIujptl = this.filteredIujptl()
      await this.$store.commit('landingpage/SET_CHECKED', {
        name: 'addedIujptl',
        filter: filterIujptl,
      })
      await this.closeModal()
    },
    filteredIujptl: function() {
      const filtered =
        this.iujptl && this.iujptl.filter(i => i.checked && i.checked == true)
      return filtered
    },
    closeModal() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_MODAL', {
        name: 'addIujptl',
        status: false,
      })
    },
  },
}
</script>
<style scoped>
.modal {
  width: 100vw;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-dialog {
  width: 100vw;
  background-color: green;
}

.modal-content {
  width: 90vw;
  position: absolute;
  transform: translateX(-30%);
}

.modal-body {
  height: 50vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
